import { createAsyncAction } from "typesafe-actions";
import { GET_AUTHORIZED_ENTITIES_FAILURE, GET_AUTHORIZED_ENTITIES_REQUEST, GET_AUTHORIZED_ENTITIES_SUCCESS, GET_AUTHORIZED_LPS_FAILURE, GET_AUTHORIZED_LPS_REQUEST, GET_AUTHORIZED_LPS_SUCCESS, GET_AUTHORIZED_LP_SELECTED_FAILURE, GET_AUTHORIZED_LP_SELECTED_REQUEST, GET_AUTHORIZED_LP_SELECTED_SUCCESS, SET_LP_PICKER_INPUT } from "./actionTypes";
export var getAuthorizedLps = createAsyncAction(GET_AUTHORIZED_LPS_REQUEST, GET_AUTHORIZED_LPS_SUCCESS, GET_AUTHORIZED_LPS_FAILURE)();
export var getAuthorizedLpSelected = createAsyncAction(GET_AUTHORIZED_LP_SELECTED_REQUEST, GET_AUTHORIZED_LP_SELECTED_SUCCESS, GET_AUTHORIZED_LP_SELECTED_FAILURE)();
export var getAuthorizedEntities = createAsyncAction(GET_AUTHORIZED_ENTITIES_REQUEST, GET_AUTHORIZED_ENTITIES_SUCCESS, GET_AUTHORIZED_ENTITIES_FAILURE)();
export function setLpPickerInput(payload) {
    return {
        type: SET_LP_PICKER_INPUT,
        payload: payload
    };
}

//# sourceMappingURL=index.js.map